// Opening_ModUI.tsx — Buildings Set1 follow-up editor for `Mod_Opening`. An Opening is a
// full-height opening that "punches out" the ENTIRE wall over its width (floor slab top → wall
// top), with no sill/frame/model — used to stop wall-mesh generation between two Rooms that are
// part of the same open space. It surfaces a single inheritable field (width) via
// `InheritableField`, with the resolved value + provenance from the §3 fallback chain, plus the
// shared "bound to wall segment" readout.
import {observer_mgl} from "mobx-graphlink";
import React from "react";
import {Text} from "react-vcomponents";
import {ObjModifier} from "../../../../../Server/DB/mapObjects/@MapObject/ObjModifier.js";
import {Mod_Opening} from "../../../../../Server/DB/mapObjects/@MapObject/ObjModifiers/Mod_Opening.js";
import {ResolveBuildingDefaults, ResolveOpeningParams, FindOwningRoom, FindOwningBuilding} from "../../../../../Server/DB/mapObjects/BuildingAccessors.js";
import {ResolveOpeningBinding} from "../../../../../Server/DB/mapObjects/BuildingGeometryAccessors.js";
import {ModifierUI_SharedProps} from "../Modifiers_CompUI.js";
import {InheritableField} from "./Building/InheritableField.js";
import {BindingReadout} from "./Door_ModUI.js";

export const Opening_ModUI = observer_mgl((props: {mod: ObjModifier} & ModifierUI_SharedProps)=>{
	const {modWrapper: mod, ChangeModWrapper, obj} = props;
	const Change = (mutator: (data: Mod_Opening)=>any)=>ChangeModWrapper(a=>mutator(a.opening!));
	const data = mod.opening!;

	const resolved = ResolveOpeningParams(obj);
	const resolvedDefaults = ResolveBuildingDefaults(obj);
	const prov = (path: string)=>resolvedDefaults.provenance[path];

	// P2 — the "bound to wall segment" readout (or a red "no wall within tolerance" warning).
	// Set2 F3: bound to the FLOOR's merged wall segments.
	const roomOwner = FindOwningRoom(obj);
	const buildingOwner = FindOwningBuilding(obj);
	const bindingRes = ResolveOpeningBinding(obj);
	const binding = bindingRes?.binding ?? null;

	return (
		<>
			<Text style={{color: "#999", fontSize: 12}}>Full-height opening in the closest ancestor Room's wall — punches out the ENTIRE wall over its width (no sill/frame). Use it to stop wall-mesh generation between two Rooms that are part of the same open space.</Text>
			<BindingReadout roomOwner={roomOwner?.obj} buildingOwner={buildingOwner?.obj} binding={binding} segment={bindingRes?.segment}/>
			<InheritableField label="Width (m)" info="Inherited via the building fallback chain (Room → Level → Building → prototypes → hardcoded)."
				resolvedValue={resolved.width} value={data.width ?? null}
				provenance={prov("opening.width")}
				onChange={(v)=>Change(a=>{ a.width = v as number|n; })}
				number={{min: 0.2, max: 10, step: 0.1}}/>
		</>
	);
});
